/**
 * src/pages/OrderConfirmed.jsx
 */
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { formatINR } from "../lib/supabaseProducts";

export default function OrderConfirmed() {
  const location = useLocation();
  const result = location.state; // { order_id, order_number, subtotal, discount, grand_total, coupon_applied }

  return (
    <div className="container-sm section text-center">
      <Helmet>
        <title>Order Placed | Ritu Fashion Store</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div style={{ fontSize: 48 }}>✅</div>
      <h1 style={{ fontSize: "1.75rem", fontWeight: 800, marginTop: 12 }}>Order placed!</h1>
      {result?.order_number && <p className="muted mt-2">Order #{result.order_number}</p>}

      {result?.grand_total != null && (
        <div className="card mt-6" style={{ background: "var(--secondary)", padding: 20, textAlign: "left", maxWidth: 320, margin: "1.5rem auto 0" }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, marginBottom: 6 }}>
            <span className="muted">Subtotal (MRP)</span>
            <span>{formatINR(result.subtotal)}</span>
          </div>
          {result.discount > result.coupon_discount && (
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, marginBottom: 6, color: "var(--primary)" }}>
              <span>Item discount</span>
              <span>−{formatINR(result.discount - (result.coupon_discount || 0))}</span>
            </div>
          )}
          {result.coupon_applied && (
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, marginBottom: 6, color: "var(--primary)" }}>
              <span>FIRST5 coupon</span>
              <span>−{formatINR(result.coupon_discount)}</span>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, fontSize: 16, borderTop: "1px solid var(--border)", paddingTop: 8, marginTop: 4 }}>
            <span>Total</span>
            <span>{formatINR(result.grand_total)}</span>
          </div>
        </div>
      )}

      <p className="muted mt-4" style={{ lineHeight: 1.6 }}>
        We'll call you shortly on the number you provided to confirm your order before it's packed and shipped.
      </p>
      <p className="muted mt-2" style={{ fontSize: 14 }}>
        Questions in the meantime?{" "}
        <a href="https://wa.me/919873804717" target="_blank" rel="noopener noreferrer">WhatsApp us</a>
      </p>
      <Link to="/shop" className="btn btn-primary mt-8">Continue shopping</Link>
    </div>
  );
}